import { observer } from 'mobx-react-lite'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { TimePicker, DropdownPlaceholder } from 'shared/ui'
import styles from './styles.module.scss'

type IScheduleTimePicker = {
  field: 'start' | 'end'
  setEveryDayTime: (date: Date | null, field: 'start' | 'end') => void
  getEveryDayTime: (field: 'start' | 'end') => Date
  minTime: Date
  maxTime: Date
}

export const ScheduleTimePicker = observer(
  ({ field, setEveryDayTime, getEveryDayTime, minTime, maxTime }: IScheduleTimePicker) => {
    return (
      <TimePicker
        onChange={(date) => setEveryDayTime(date, field)}
        selected={getEveryDayTime(field)}
        filteredPassedTime={minTime}
        filteredRemainingTime={maxTime}
        minuteStep={15}
        customContent={({ dropdownItems, handleChange, inputValue }) => {
          return (
            <DropdownPlaceholder
              items={dropdownItems}
              onChange={handleChange}
              placeholder={inputValue || 'Select time'}
              textPlaceholderProps={{
                variant: 'stroke',
                size: 'small',
                className: styles.inputTimePicker,
                rightActions: [
                  makeTextFieldIcon({
                    icon: 'chevronDown',
                    color: 'var(--content-neutral-primary)',
                  }),
                ],
              }}
            />
          )
        }}
        textFieldPlaceholderProps={{
          variant: 'stroke',
          leftActions: [],
          rightActions: [
            makeTextFieldIcon({
              icon: 'chevronDown',
              color: 'var(--content-neutral-primary)',
            }),
          ],
        }}
        topListTextFieldProps={{
          leftActions: [],
          readOnly: true,
        }}
      />
    )
  }
)
